export default {
  siteservice: '全球服务: 现场服务',
  siteservicetext: `
  我们以客户为中心，倾听客户诉求，组建专业本土技术团队，我们提供涵盖产品全生命周期的服务和解决方案 我们以专业、高效的服务，不断超越客户期望，为客户创造更大价值。
  `,
  engineer: '技术服务工程师',
  provider: '全球授权服务商',
  network: '服务网点',
  storage: '仓库区域',

  support: '原厂技术支持',
  Local: '本地化服务',
  global: '专家资源全球调配',

  s1: '原装技术赋能，全程售后护航，一对一原厂技术，精准解决难题',
  s2: '深耕本土市场，搭建完善本地化服务体系，就近布局服务网点，组建专业本土技术团队',
  s3: '以全球视野、本地落地的服务模式，精准攻克各类技术难题，为客户提供高水准专业支撑',

  Remote: '全球服务:远程服务',
  Remotetext: `依托云端技术架构，打造全球卓越远程服务体系。跨地域无缝对接，不受时空距离限制，提供专业在线运维、技术支持、系统调试与专属咨询服务。高效响应、实时协同、全程可控，以标准化流程与专业实力，为海内外客户交付稳定、可靠、高品质的一站式远程解决方案。 `,

  online: '服务在线',
  online24: '全天候远程支持服务在线',
  guidance: '实时操作指导',
  thoroughly: '技术人员会随时实时操作指导，解决现场所有问题！',
  equipment: '设备调试',
  schedule: '技术人员专业设备调试',

  training: '现场培训',
  operation: '根据现场实操进行现场培训',
};
